export default __webpack_public_path__ + "static/tmb-2-6af23f9925b00a2d81ee70e0455a1d35.png";